import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { useRegister, useResendEmail } from '../hooks/useAuth';
import { RegisterModal } from '../components/modals/RegisterModal';
import { cleanValue, processErrors, registrSchema } from '../utils/authUtils';
import { DescriptionAlert, StyledTitle } from './Register.styled';
import { RegisterForm } from '../components/forms/RegisterForm';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import { META_DATA } from '../utils/constants';
import { Helmet } from 'react-helmet-async';

const Register = () => {
  const { redigisterNewUser, isRegistering } = useRegister();
  const { resendEmail, isResendingEmail } = useResendEmail();

  const { title, description, keywords } = META_DATA?.registration; 

  const [user, setUser] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    role: '',
    name: '',
    lastName: '',
    email: '',
    password: '',
  });
  const { isAuthenticated, checkAuthentication} = useAuth();
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    const cleanVal = cleanValue(name, value);

    setFormData(prevData => ({
      ...prevData,
      [name]: cleanVal,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      await registrSchema.validateAsync(formData, { abortEarly: false });
      const userData = await redigisterNewUser(formData);
      setUser(userData);
      setOpenModal(true);
      setFormData({
        role: '',
        name: '',
        lastName: '',
        email: '',
        password: '',
      });
    } catch (error) {
      processErrors(error);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);    
  };

  useEffect(() => { 
    if (isAuthenticated) {
      navigate('/dashboard?tab=classroom');
    }    
  },[isAuthenticated]);

  return (
    <>
      <Helmet>
                <title>{title}</title>
                <meta name="keywords" content={keywords} />                
                <meta name="description" content={description} />
      </Helmet>

    <Container maxWidth="sm">
        <StyledTitle>Registrazione: indica il tuo ruolo per iniziare</StyledTitle>
        <DescriptionAlert>
          ⚠️ Attenzione: Ti chiediamo di <b>non usare email scolastiche</b>, ma preferire provider
          come Gmail, Outlook, Yahoo o altri servizi personali, perché le email di verifica
          potrebbero non arrivare a causa di restrizioni scolastiche.
        </DescriptionAlert>
      <RegisterForm
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isRegistering={isRegistering}
      />
      <RegisterModal
        open={openModal}
        onClose={handleCloseModal}
        userEmail={user && user.email}
        resendEmail={resendEmail}
        isResendingEmail={isResendingEmail}
      />
    </Container>
    </>
  );
};

export default Register;